import * as Api from '@/utils/request'

export default {
	async getUserInfo() {
        return await Api.get({
            url: '/H5ReactUserCenter/index'
        }) 
    },
    
 
    //获取分享的数据
    async getShare(params){
        return await Api.get({
            url:'/H5/replica_details_share',
            params
        })
    },
}